export default __webpack_public_path__ + "static/media/investors_logo2.6cffc9b6.png";